import { apiClient } from './client'
import type { ApiResponse } from './client'
import type {
  IntegrationConnectionCreateDto,
  IntegrationConnectionViewDto,
  IntegrationConnectionListResponse,
  IntegrationConnectionUpdateDto,
  IntegrationErrorSummaryDto
} from '@/types/integrations'

export const integrationsApi = {
  getIntegrationConnections: (clientCompanyId: string): Promise<ApiResponse<IntegrationConnectionListResponse>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations`),

  createIntegrationConnection: (clientCompanyId: string, dto: IntegrationConnectionCreateDto): Promise<ApiResponse<IntegrationConnectionViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations`, dto),

  updateIntegrationConnection: (clientCompanyId: string, id: string, dto: IntegrationConnectionUpdateDto): Promise<ApiResponse<null>> =>
    apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Integrations/${id}`, dto),

  deleteIntegrationConnection: (clientCompanyId: string, id: string): Promise<ApiResponse<null>> =>
    apiClient.delete(`/api/ClientCompanies/${clientCompanyId}/Integrations/${id}`),

  resetIntegrationConnection: (clientCompanyId: string, id: string): Promise<ApiResponse<IntegrationConnectionViewDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/${id}/Reset`, {}),

  getIntegrationErrorSummary: (clientCompanyId: string, integrationId: string): Promise<ApiResponse<IntegrationErrorSummaryDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/${integrationId}/ErrorSummary`),
}
